var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGiticon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 32,
    viewBox: "0 0 35 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.14118 27C11.2082 27 12.8839 25.433 12.8839 23.5C12.8839 21.567 11.2082 20 9.14118 20C7.07412 20 5.39844 21.567 5.39844 23.5C5.39844 25.433 7.07412 27 9.14118 27Z",
    stroke: "#20996B",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.14118 12C11.2082 12 12.8839 10.433 12.8839 8.5C12.8839 6.567 11.2082 5 9.14118 5C7.07412 5 5.39844 6.567 5.39844 8.5C5.39844 10.433 7.07412 12 9.14118 12Z",
    stroke: "#20996B",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.1416 12V20",
    stroke: "#20996B",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M25.1822 27C27.2493 27 28.9249 25.433 28.9249 23.5C28.9249 21.567 27.2493 20 25.1822 20C23.1151 20 21.4395 21.567 21.4395 23.5C21.4395 25.433 23.1151 27 25.1822 27Z",
    stroke: "#20996B",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M25.1816 20L25.1814 14.9851C25.1813 13.3939 24.5053 11.8679 23.3021 10.7427L18.2305 6",
    stroke: "#20996B",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M18.2305 11V6H23.5772",
    stroke: "#20996B",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGiticon);
export default __webpack_public_path__ + "static/media/giticon.c77f42de3b2463101f980f934aa38d0b.svg";
export { ForwardRef as ReactComponent };